import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthStorageService } from '../services/auth-storage.service';

const PUBLIC_URL_PATTERN = /\/users\/login|\/user\/signup|\/user\/password|\/user\/confirm-registration|\/user\/mfa\/verify-login|\/user\/mfa\/resend-login-otp/i;
const SESSION_EXPIRED_PATTERN = /invalid token|session expired|authorization token missing|please login again|no token information found|role or permissions were updated|permissions changed/i;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private loggingOut = false;

  constructor(
    private router: Router,
    private authStorage: AuthStorageService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const jwtToken = this.authStorage.getJwtToken();

    if (jwtToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (this.shouldForceLogout(request, error)) {
          this.forceLogout();
        }
        return throwError(() => error);
      })
    );
  }

  private shouldForceLogout(request: HttpRequest<unknown>, error: any): boolean {
    if (error?.status !== 401 || this.loggingOut) {
      return false;
    }
    const url = request.url || '';
    if (PUBLIC_URL_PATTERN.test(url)) {
      return false;
    }
    if ((this.router.url || '').includes('users/login')) {
      return false;
    }
    const message = String(error?.error?.message || error?.message || '');
    return SESSION_EXPIRED_PATTERN.test(message);
  }

  private forceLogout() {
    this.loggingOut = true;
    this.authStorage.clear();
    this.router.navigateByUrl('users/login').finally(() => {
      this.loggingOut = false;
    });
  }
}
